import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { prop } from 'ramda'
import {
  getFeatureMetadata,
  getFeatureModuleType,
} from 'selectors/feature/featureMetadata'

import {
  deleteSingleCondition,
  setConditionField,
  resetCondition,
  resetConditionShowHelp,
  addSuggestedOutput,
} from 'actions/feature/conditions'

import { CARRY } from 'utils/constants'
import { makeConditionSelector } from 'selectors/feature/conditions'
import {
  getIsSixteenBitCanOutput,
  getNewOutputNodeIndex,
  getOutputConfigAssessment,
} from 'selectors/feature/outputs'

import ConditionEditor from './ConditionEditor'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()

  return (state, ownProps) => {
    const { fnId, uri } = ownProps

    const isSixteenBitCanOutput = getIsSixteenBitCanOutput(state, {
      id: fnId,
    })
    const featureMetadata = getFeatureMetadata(state)
    const { moduleName } = featureMetadata
    const moduleType = getFeatureModuleType(state)
    const newOutputNodeIndex = getNewOutputNodeIndex(state)

    const condition = conditionSelector(state, {
      queryUri: uri,
    })
    const { parentType } = condition
    const isSingleCondition = !parentType
    const subType = prop('subType', condition)
    const hasCarryType = subType === CARRY
    const isCanInput = subType === 'can'
    const outputConfig = getOutputConfigAssessment(state, { id: fnId })

    return {
      ...ownProps,
      ...condition,
      isSingleCondition,
      isCanInput,
      hasCarryType,
      isSixteenBitCanOutput,
      moduleName,
      moduleType,
      newOutputNodeIndex,
      outputConfig,
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { uri } = ownProps

  const setField = (fieldName) => (value) =>
    setConditionField(uri, fieldName, value)

  return bindActionCreators(
    {
      toggleMarkForDeletion: setField('markedForDeletion'),
      deleteSingleCondition,
      resetCondition,
      resetConditionShowHelp,
      addSuggestedOutput,
    },
    dispatch
  )
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { newOutputNodeIndex } = stateProps

  const {
    deleteSingleCondition: dispatchDeleteSingleCondition,
    resetCondition: dispatchResetCondition,
    resetConditionShowHelp: dispatchResetHelpPopup,
    addSuggestedOutput: dispatchAddOutputNode,
  } = dispatchProps
  const { uri, fnId } = ownProps

  const deleteCondition = () => {
    dispatchDeleteSingleCondition(uri, fnId)
  }

  const addOutputNode = (tmpId, relativeOutput) => {
    dispatchAddOutputNode(relativeOutput, tmpId, fnId, newOutputNodeIndex, uri)
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    deleteCondition,
    resetCondition: () => dispatchResetCondition(uri),
    resetHelpPopup: () => dispatchResetHelpPopup(uri),
    addOutputNodeHandler: (tmpId, relativeOutput) =>
      addOutputNode(tmpId, relativeOutput),
  }
}

const connected = connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ConditionEditor)

export default connected
